import { useState, useEffect } from 'react';

const base64Image =
  'AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';

interface UseSupportedImageFormatProps {
  isAnimated?: boolean;
}

export const useSupportedImageFormat = ({ isAnimated = false }: UseSupportedImageFormatProps) => {
  const [supportedFormat, setSupportedFormat] = useState<'avif' | 'webp' | 'png' | 'gif'>('avif');

  useEffect(() => {
    const checkImageFormat = async () => {
      const isAvifSupported = await isFormatSupported('avif', base64Image);
      if (isAvifSupported) {
        setSupportedFormat('avif');
      } else {
        const isWebpSupported = await isFormatSupported('webp', base64Image);
        if (isWebpSupported) {
          setSupportedFormat('webp');
        } else {
          setSupportedFormat('png');
        }
      }
    };
    const checkAnimatedImageFormat = async () => {
      const isWebpSupported = await isFormatSupported('webp', base64Image);
      if (isWebpSupported) {
        setSupportedFormat('webp');
      } else {
        setSupportedFormat('gif');
      }
    };

    isAnimated ? checkAnimatedImageFormat() : checkImageFormat();
  }, [isAnimated]);

  return { supportedFormat };
};

const isFormatSupported = (format, dataUri) =>
  new Promise((resolve) => {
    const image = new Image();

    image.onload = () => {
      resolve(true);
    };

    image.onerror = () => {
      resolve(false);
    };

    image.src = `data:image/${format};base64,${dataUri}`;
  });
